import { Component, OnInit, Inject } from '@angular/core';
import { StepComponent, _, ICC_PAGE_DATA, SharedFacade, ConfiguratorOptions } from '@icc/configurator/shared';
import { iccListItem } from '@icc/configurator/ui';
import { Observable } from 'rxjs';
import { WindowFacade } from 'libs/configurator/window/src/lib/+state/window.facade';
import { map } from 'rxjs/operators';
import { LocksService } from '@icc/legacy/configurator/steps/door/locks/locks.service';
import { WindowActiveConfiguration } from '@icc/common/configurations/WindowActiveConfiguration';
@Component({
    selector: 'icc-locks',
    templateUrl: './locks.component.html',
    styleUrls: ['./locks.component.scss'],
})
export class LocksComponent extends StepComponent implements OnInit {
    static stepName = _('STEPS|Zamki');
    static stepIcon = {
        ligature: 'lock',
    };
    public configurator = 'door';
    public stepId = 'locks';
    public title = _('WINDOW|Wybierz zamek');

    selectedLock$ = this.windowFacade.selectedLock$;

    locks: iccListItem[] = [];

    static stepEnable = (conf: WindowActiveConfiguration, options: ConfiguratorOptions) =>
        conf.type === 'door' && (!conf.System || !Boolean(conf.System.door_type));

    constructor(
        private windowFacade: WindowFacade,
        private sharedFacade: SharedFacade,
        private locksService: LocksService
    ) {
        super();
    }

    ngOnInit() {
        this.locks = this.locksService.locks.map(lock => ({
            id: Number(lock.id),
            title: lock.name,
            imageUrl: '/files/windowaccessory/' + lock.img,
        }));
    }

    selectLock(item: iccListItem) {
        const lock = this.locksService.locks.find(l => Number(l.id) === item.id);
        this.locksService.selectLock(lock);
    }

    lockBySystem() {
        this.locksService.findLocksBySystem();
    }
}
